<div #dockContainer style="--size: {{ncSize}};" class="dock-container"
    [ngClass]="{'light-mode': ncTheme === 'light', 'dark-mode': ncTheme === 'dark', 'horizontal-mode': ncDirection === 'horizontal', 'vertical-mode': ncDirection === 'vertical'}">
    <ng-container *ngFor="let item of ncItems; let i = index">
        <div class="dock-icon" [ngStyle]="{'width': iconScales[i] + 'px', 'height': iconScales[i] + 'px'}">
            <div class="icon-image-container"
                [ngClass]="{'magnification-mode': ncMode === 'magnification', 'distance-mode': ncMode === 'distance', 'hover-mode': ncHover}"
                (click)="onIconClick(i)">
                <ng-container *ngIf="isSvgContent(item); else imageTemplate">
                    <div class="dock-icon-image" [innerHTML]="getSanitizedSvg(item)"></div>
                </ng-container>
                <ng-template #imageTemplate>
                    <img [src]="item" class="dock-icon-image">
                </ng-template>
            </div>
            <div *ngIf="ncTooltip && ncTooltip[i]" class="dock-tooltip" [ngClass]="'tooltip-' + ncTooltipPosition">
                {{ ncTooltip[i] }}
            </div>
        </div>
        <div class="dock-divider" *ngIf="ncDividerIndex.includes(i)"></div>
    </ng-container>
</div>